export const footer = {
  uz: {
    footerText:
      "Ko’z kasalliklarini davolashda professionallar jamoasi, <br/> <b>Choriqul Shaymatov Gavhari</b> <br/> klinikasiga xush kelibsiz.",
    footerAboutUs: "Biz haqimizda",
    footerAboutClinic: "Klinika haqida",
    footerAboutDoctor: "Shifokorlar",
    footerAboutEyeDisease: "Ko'z kasalliklari",
    footerAboutReview: "Sharhlar",
    footerAboutFAQ: "Tez-tez so'raladigan savollar",
    footerService: "Xizmatlar",
    footerServiceAll: "Barcha xizmatlar",
    footerServiceEyeFullCheck: "Ko'zni keng qamrovli tekshirish",
    footerServiceContactLensCheck: "Katarakta xirurgiyasi",
    footerServiceFullOpticCheck: "Glaukomani davolash",
    footerServiceEyeCare: "Lazerli ko'z korrektsiyasi",
    footerContact: "Kontaktlar",
    footerCopyright:
      "Choriqul Shaymatov Gavhari Veb-sahifasining barcha mualliflik huquqlari himoyalangan",
    footerAddressText: "Samarqand shahri, <br/> Mirzo Ulug'bek ko'chasi, 3",
    footerAddressText2:
      "Navoiy viloyati, Xatirchi tumani, <br/> Farxod ko’chasi, 1 uy",
  },
  ru: {
    footerText:
      "Добро пожаловать клинику <br/> <b>Choriqul Shaymatov Gavhari</b>, <br/> где профессионалы заботятся о ваших глазах",
    footerAboutUs: "О нас",
    footerAboutClinic: "О клинике",
    footerAboutDoctor: "Врачи",
    footerAboutEyeDisease: "Глазные болезни",
    footerAboutReview: "Отзывы",
    footerAboutFAQ: "Часто задаваемые вопросы",
    footerService: "Услуги",
    footerServiceAll: "Все услуги",
    footerServiceEyeFullCheck: "Комплексное обследование глаз",
    footerServiceContactLensCheck: "Хирургия катаракты",
    footerServiceFullOpticCheck: "Лечение глаукомы",
    footerServiceEyeCare: "Лазерная коррекция зрения",
    footerContact: "Контакты",
    footerCopyright:
      "Все авторские права на веб-страницу Choriqul Shaymatov Gavhari защищены",
    footerAddressText: "город Самарканд, <br/> улица Мирзо Улугбека, 3",
    footerAddressText2:
      "область Навои, район Хатирчи, <br/>  улица Фархад, дом 1",
  },
  tj: {
    footerText:
      "То ҷое ки ман мефаҳмам, ҳар як реҷаи мо барои ба даст овардани чизе аз он саъйи зиедро талаб мекунад, ин як дорухат барои истифодабаранда аст",
    footerAboutUs: "Дар бораи мо",
    footerAboutClinic: "Дар бораи клиника",
    footerAboutDoctor: "Духтурон",
    footerAboutEyeDisease: "Бемориҳои чашм",
    footerAboutReview: "Тафсирњои",
    footerAboutFAQ: "Саволҳои зуд-зуд додашаванда",
    footerService: "Хизматрасонӣ",
    footerServiceAll: "Ҳама хидматҳо",
    footerServiceEyeFullCheck: "Муоинаи ҳамаҷонибаи чашм",
    footerServiceContactLensCheck: "Санҷиши линзаҳои контактӣ",
    footerServiceFullOpticCheck: "Хизматрасонии пурраи оптикӣ",
    footerServiceEyeCare: "Нигоҳубини чашм",
    footerContact: "Тамос",
    footerCopyright:
      "Ҳама ҳуқуқи муаллифӣ Ба вебсайти Choriqul Shaymatov Gavhari ҳифз карда шудааст",
    footerAddressText1: "шаҳри Самарқанд, <br/> кӯчаи Мирзо Улуғбек, 3",
    footerAddressText2:
      "область Навои, район Хатирчи, <br/>  улица Фархад, дом 1",
  },
};
